/* Array che tiene traccia dell'utlimo elemento di ogni pagina
[] | [{'machine': id macchina, 'test': id test}]
*/
import { createContext } from "react";
const PagesLastItemContext = createContext({
    pagesLastItem: [],
  });
export default PagesLastItemContext;